/**
 * Fallback user-facing module display name (browser tab, breadcrumbs, headers).
 * Prefer `module_display_name` from `GET /global/config` when present.
 * Internal protocol/storage keys may still use historical "regulations-next" ids.
 */
export const MODULE_DISPLAY_NAME = "Regulations Next";

/** Resolve API `module_display_name` with the static fallback. */
export function resolveModuleDisplayName(
  moduleDisplayName?: string | null,
): string {
  const trimmed = moduleDisplayName?.trim();
  return trimmed ? trimmed : MODULE_DISPLAY_NAME;
}
